/* eslint-disable import/prefer-default-export */
import { ApiResponse } from '../@types';
import { request } from '../../utils';
import { TUSStateCities, TUSStateCitiesResponse } from './@types';

export const getUSStates = (): Promise<ApiResponse<TUSStateCities[]>> => {
  return request({
    url: 'us-states',
    method: 'GET',
  });
};

export const getUSStateCities = (
  stateName: string,
): Promise<ApiResponse<TUSStateCitiesResponse>> => {
  return request({
    url: 'us-states-cities',
    method: 'GET',
    params: {
      stateName,
    },
  });
};

export const getSchoolsByState = ({ state, search }: any): Promise<ApiResponse<any>> => {
  return request({
    url: 'school-by-state',
    method: 'GET',
    params: {
      state,
      search,
    },
  });
};
